import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'dbm-additional-options',
    template: require('./dbm-additional-options.component.html'),
    styles: [require('./dbm-additional-options.component.scss')]
})
export class DbmAdditionalOptionsComponent implements OnInit {
    @Input() public isOpenEditMode: boolean;
    @Input() public totalItemsPerRow: number;

    @Input()
    public set items(value: any[]) {
        if (value) {
            this.ITEMS = value;
            this.dataProcessing();
        }
    }

    public get items(): any[] {
        return this.ITEMS;
    }

    private ITEMS: any[];
    public groups: any[];

    public ngOnInit() {
    }

    private dataProcessing(): void {
        this.groups = this.items.slice();
        this.groups.forEach((group) => {
            const groupOptions = [];
            const tempItems: any[] = group.optionsList.slice();
            const shift = tempItems.length % this.totalItemsPerRow !== 0 ? 1 : 0;
            const length = tempItems.length / this.totalItemsPerRow + shift;

            tempItems.forEach((item, index) => {
                item.idx = index;
            });
            for (let i = 0; i < length; i++) {
                const options = tempItems.splice(0, this.totalItemsPerRow);
                if (options.length > 0) {
                    groupOptions.push(options.map(item => item));
                }
            }
            group.groupOptions = groupOptions;
        });
    }

    public computeItemCss(last: boolean) {
        return last ? 'row items-style-last' : 'row items-style';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.component.ts